<template>
  <ul class="menu">
    <li class="workspace">
      <Text type="p" weight="600" class="name">{{ workspace.name }}</Text>
      <button v-if="teams.length > 1" class="switch" @click.stop="emit('switch')">
        {{ $t('header.switch_workspace') }}
      </button>
    </li>
    <li class="mobile">
      <router-link :to="{ name: 'Feed' }" class="link">{{ $t('header.feed') }}</router-link>
    </li>
    <li class="mobile">
      <router-link :to="{ name: 'RewardsShop' }" class="link">{{ $t('header.rewards') }}</router-link>
    </li>
    <li v-if="isGlobalAdmin || isAccountAdmin" class="mobile">
      <router-link
        :to="{ name: 'Dashboard' }"
        class="link"
        @click="gtmEventTracker('dashboard_view', 'Dashboard_view', 'click', 'Dashboard view nav menu')"
      >
        {{ $t('header.dashboard') }}
      </router-link>
    </li>
    <li class="profile">
      <router-link :to="{ name: 'Profile', params: { id: currentUser.id } }" class="link with-border-bottom">
        {{ $t('header.profile') }}
      </router-link>
    </li>
    <li v-if="isGlobalAdmin || isAccountAdmin || isRewardsAdmin || isBillingAdmin">
      <router-link to="/settings" class="link">{{ $t('header.settings') }}</router-link>
    </li>
    <li v-if="isGlobalAdmin || isAccountAdmin">
      <router-link to="/settings/team" class="link">{{ $t('header.management.team') }}</router-link>
    </li>
    <li v-if="isRewardsAdmin || isBillingAdmin">
      <router-link
        to="/settings/rewards"
        class="link"
        @click="gtmEventTracker('rewards_management_click', 'Rewards_management', 'click', 'Rewards management nav menu')"
      >
        {{ $t('header.management.rewards') }}
      </router-link>
    </li>
    <li v-if="isBillingAdmin">
      <router-link
        to="/settings/billing"
        class="link with-border-bottom"
        @click="gtmEventTracker('billing_management_click', 'Billing_management', 'click', 'Billing management nav menu')"
      >
        {{ $t('header.management.billing') }}
      </router-link>
    </li>
    <li class="link" @click="onSignOut">
      {{ $t('header.logout') }}
    </li>
  </ul>
</template>

<script setup>
import { Text } from '@sliday/karma-ui-library';
import { defineEmits, inject, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import gtmEventTracker from '@/utils/gtmEventTracker';

const store = useStore();
const router = useRouter();
const emit = defineEmits(['switch']);
const workspace = inject('workspace');
const currentUser = computed(() => store.state.auth.currentUser);
const teams = computed(() => store.state.auth.workspaces);
const isGlobalAdmin = computed(() => store.state.auth.permissions.global_administrator);
const isAccountAdmin = computed(() => store.state.auth.permissions.account_administrator);
const isRewardsAdmin = computed(() => store.state.auth.permissions.rewards_administrator);
const isBillingAdmin = computed(() => store.state.auth.permissions.billing_administrator);

async function onSignOut() {
  try {
    await store.dispatch('auth/logout');
    router.push({ name: 'Login' });
  } catch (e) {
    console.log(e);
  }
}
</script>

<style scoped lang="scss">
.menu {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;

  li {
    &.mobile {
      display: none;
      @include sm {
        display: block;
      }
    }

    &.workspace {
      width: 100%;
      padding: 12px 16px;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid $gray-border;

      .name {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .switch {
        cursor: pointer;
        background-color: transparent;
        color: var(--color-active);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        padding: 0;
        margin: 2px 0 0;
        text-align: start;
      }
      @include sm {
        border-top: 1px solid $gray-border;
        .switch {
          margin-top: 4px;
        }
      }
    }

    &.profile {
      @include sm {
        border-top: 1px solid $gray-border;
      }
    }
  }

  .link {
    text-decoration: none;
    padding: 8px 16px;
    background-color: #fff;
    cursor: pointer;
    display: block;
    color: $dark-text;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    &:hover {
      background-color: rgba(28, 46, 57, 0.05);
    }
    @include sm {
      padding: 12px 16px;
      font-size: 16px;
      line-height: 24px;
      &:hover {
        background-color: #fff;
      }
    }

    &.with-border-bottom {
      border-bottom: 1px solid $gray-border;
    }
  }
}
</style>
